export const FETCH_CONSENTS_LIST = 'FETCH_CONSENTS_LIST';
export const FETCH_CONSENTS_LIST_SUCCESS = 'FETCH_CONSENTS_LIST_SUCCESS';
export const FETCH_CONSENTS_LIST_FAILURE = 'FETCH_CONSENTS_LIST_FAILURE';
export const CLEAR_CONSENTS_LIST = 'CLEAR_CONSENTS_LIST';
